import { Typography } from "@mui/material";
import NotificationItem from "./component/NotificationItem";

const Section = ({ title, items, mt = 0 }: { title: string; items: any[]; mt?: number }) => (
  <>
    <Typography
      component="p"
      sx={{
        fontFamily: "Inter",
        fontWeight: 600,
        fontSize: "14px",
        color: "#7D8690",
        pl: "14px",
        mt,
        mb: 1,
      }}
    >
      {title}
    </Typography>
    {items.map((n) => (
      <NotificationItem key={n.uid} notification={n} />
    ))}
  </>
);
export default Section;
